export default __webpack_public_path__ + "static/media/slider-bg1.9b3604af.jpg";